import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { Redirect } from 'react-router-dom';
import { object_type, api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from '../../../UseToken';
import Loader from '../../Loader/Loader';
import Swal from 'sweetalert2'
import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	obter_cidades_por_distrito,
	obter_freguesias_por_cidade,
	//obter_distrito_por_cidade,
	obter_paises_em_pt,
	obter_distritos_pt,
	//get_vat_info,
	pattern_vat,
	pattern_email, 
	passwordHash,
} from '../../../Utils';
import { language } from './Language';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import CountrySelector from "./CountrySelector"


export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(data_interface);
	const [lang, /*set_lang*/] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_password, /*set_is_password*/] = useState(false)
	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')

	//const [is_input_disabled, set_is_input_disabled] = useState(true);

	const [is_edit, set_is_edit] = useState(false)

	//const [newDate, ] = useState(new Date())
	//const [today , ] = useState(newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, "0") + '-' + newDate.getDate().toString().padStart(2, "0"))

	const [/*show_district_city_village*/, set_show_district_city_village] = useState('');

	const [/*disabled*/, set_disabled] = useState(false)

	const entity_types = [
		{ value: "Ski", label: "Ski" },
		{ value: "Snowboard", label: "Snowboard" }
	];

	const identification_types = [
		{ value: "Bilhete de Identidade", label: "Bilhete de Identidade" },
		{ value: "Cartão de Cidadão", label: "Cartão de Cidadão" }
	];

	// BIA
	//estado para armazenar o valor do departamento
	const [selectedDepartment, setSelectedDepartment] = useState(dados.current.info.departments || '');
	const [inputValueDepartaments, setInputValueDepartaments] = useState('');
    const [submittedValuesDepartaments, setSubmittedValuesDepartaments] = useState([]);

	//estado para armazenar valor da função dos empregados
	const [inputValueEmployeerFunction, setInputValueEmployeerFunction] = useState(dados.current.info.employeer_function || '');
  	const [submittedValueEmployeerFunction, setSubmittedValueEmployeerFunction] = useState('');

  	const [inputValueEmployeerType, setInputValueEmployeerType] = useState('');
  	const [submittedValueEmployeerType, setSubmittedValueEmployeerType] = useState('');

  // função para capturar a tecla Enter
  const handleKeyDownEmployeerFunction = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();  // impede o comportamento padrão de submit em forms
      setSubmittedValueEmployeerFunction(inputValueEmployeerFunction);
	  setInputValueEmployeerFunction('')
    }
  };

  // função para lidar com as mudanças no input
  const handleChangeEmployeerFunction = (event) => {
    setInputValueEmployeerFunction(event.target.value);
    handle_change_info(event);  // continua a chamar a função de handle_change_info, se necessário
  };

    const handleChangeDepartaments = (e) => {
        setInputValueDepartaments(e.target.value);
    };

	//add um novo departamento ao pressionar Enter
    const handleKeyDownDepartaments = (e) => {
        if (e.key === 'Enter' && inputValueDepartaments.trim() !== '') {
            setSubmittedValuesDepartaments([...submittedValuesDepartaments, inputValueDepartaments]);
            setInputValueDepartaments('');
        }
    };


	//remover?
	// manipular a mudança de seleção do departamento
	// const handleSelectDepartment = (e) => {
	// 	setSelectedDepartment(e.target.value);
	// //atualiza o valor de 'departaments´na estrutura de dados
	// 	dados.current.info.departments = e.target.value;
	// };

 // função para capturar a tecla Enter
 const handleKeyDownEmployeerType = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); 
      console.log("Enter key pressed!");  
      setSubmittedValueEmployeerType(inputValueEmployeerType); 
      setInputValueEmployeerType('');  
    }
  };

  //  lidar com as mudanças no input
  const handleChangeEmployeerType = (e) => {
    setInputValueEmployeerType(e.target.value);
  };

	// FINAL BIA
	const [countries, set_countries] = useState([])
	const [districts, set_districts] = useState([])
	const [cities, set_cities] = useState([])
	const [villages, set_villages] = useState([])

	// INICIO CÓDIGO bia parte 2 - estado e modal para departamentos
	const [departamentoInput, setDepartamentoInput] = useState('');
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [modalResponsavel, setModalResponsavel] = useState(false);

	//add responsible for each department
	const [responsavelInputNome, setresponsavelInputNome] = useState('');
	const [responsavelInputTel, setresponsavelInputTel] = useState('');
	const [departamentoSelecionado, setDepartamentoSelecionado] = useState('');
	const [departamentoid, setDepartamentoId] = useState();

	//add estado para armazenar responsável recem adicionado para por dentro de um botão
	const [responsavelAdicionado, setResponsavelAdicionado] = useState(null);

	// ADICIONAR ENTIDADES - SEGUNDA ATIVIDADE DO DOMINGOS

	// controla qual entidade está atualmente selecionada e visível na interface.
	const [activeEntityId, setActiveEntityId] = useState(null);

	// controla qual DOMÍNIO está atualmente selecionada e visível na interface.
	const [activeDomainId, setActiveDomainId] = useState(null);
	
	//indica se o formulário de adição de uma nova entidade está visível.
	const [isAdding, setIsAdding] = useState(false);

	//indica se o formulário de adição de um novo domínio está visível.
	const [isAddingDomain, setIsAddingDomain] = useState(false);

	//mantem os valores dos campos do formulário para uma nova entidade.
	const [newEntity, setNewEntity] = useState({
		nomeEntidade: '',
		morada: '',
		codigoPostal: '',
		localidade: '',
		pais: '',
		dataPrimeiroRegisto: '',
		nif: '',
		telf: '',
		telm: '',
		nomeDominio: '',
		ssl: '',
		responsavelGestaoDominio: '',
		email: '',
		site: '',
		obs: ''
	});

	//mantem os valores dos campos do formulário para um novo domínio
	const [newDomain, setNewDomain] = useState({
		nomeEntidade: '',
		morada: '',
		codigoPostal: '',
		localidade: '',
		pais: '',
		dataPrimeiroRegisto: '',
		nif: '',
		telf: '',
		telm: '',
		nomeDominio: '',
		ssl: '',
		responsavelGestaoDominio: '',
		email: '',
		site: '',
		obs: ''
	});
	
	//guarda a lista de entidades
	const [entities, setEntities] = useState([
		{
			id: "",
			nomeEntidade: " ",
			morada: " ",
			codigoPostal: "",
			localidade: " ",
			pais: "",
			dataPrimeiroRegisto: "",
			nif: "",
			nomeDominio: "",
			ssl: "",
			responsavelGestaoDominio: " ",
			email: "",
			site: "",
			obs: "",
		}
	])

	//guarda a lista de domínios
	const [dominios, setDominios] = useState([
		{
			id: "",
			nomeEntidade: " ",
			morada: " ",
			codigoPostal: "",
			localidade: " ",
			pais: "",
			dataPrimeiroRegisto: "",
			nif: "",
			nomeDominio: "",
			ssl: "",
			responsavelGestaoDominio: " ",
			email: "",
			site: "",
			obs: "",
		}
	])

	// add state para manter a entidade atualmente em edição e para armazenar os valores editados
	const [editingEntityId, setEditingEntityId] = useState(null);
	const [editedEntity, setEditedEntity] = useState({});

	// add state para manter o dominio atualmente em edição e para armazenar os valores editados
	const [editingDomainId, setEditingDomainId] = useState(null);
	
	const [editedDomain, setEditedDomain] = useState({
		nomeDominio: '',
		dataPrimeiroRegisto: '',
		validade: '',
		gestor: '',
		obs: ''
	  })

	const [previousDomain, setPreviousDomain] = useState({
		nomeDominio: '',
		dataPrimeiroRegisto: '',
		validade: '',
		gestor: '',
		obs: ''
	});

	  const [history, setHistory] = useState([]);
	  const [showHistory, setShowHistory] = useState(false);

	// atualiza os valores de newEntity à medida que o user preenche o formulário
	const handleChange = (e) => {
		const { name, value } = e.target;
		
		console.log(`campo alterado: ${name}, novo valor: ${value}`);
		// atualizar a entidade
		setNewEntity(prevEntity => {
			const updatedEntity = {
				...prevEntity,
				[name]: value
			};
			console.log("Entidade atualizada:", updatedEntity);
			return updatedEntity;
		});
			console.log("estrutura atual de dados.current.info.entidades:", dados.current.info.entidades);
	};
	
	// atualiza os valores de newEntity à medida que o user preenche o formulário
	const handleChangeDomain = (e) => {
		const { name, value } = e.target;
		
		console.log(`campo alterado: ${name}, novo valor: ${value}`);
		
		// atualizar a entidade
		setNewDomain(prevDomain => {
			const updatedDomain = {
				...prevDomain,
				[name]: value
			};
			console.log("domínio ou entidade atualizada:", updatedDomain);
			return updatedDomain;
		});
	
		// verificar a estrutura de dados.current.info.entidades
		console.log("estrutura atual de dados.current.info.entidades:", dados.current.info.entidades);
	};
	
	//veriica se newEntity tem um nomeEntidade antes de adicionar a nova entidade ao array de entidades dentro de dados.
	//Após adicionar, limpa o form e oculta a interface de adição (isAdding)
	const addEntity = (e) => {
        e.preventDefault();
		console.log("tentar adicionar uma nova entidade:", newEntity);

        if (newEntity && newEntity.nomeEntidade && newEntity.nif && newEntity.pais) {
            const entityId = Date.now().toString();
            const entityToAdd = { ...newEntity, id: entityId };
			// console.log("entidade a ser adicionada:", entityToAdd);

			//adiciono a entidade
            dados.current.info.entidades.push(entityToAdd); 
            set_dados({ ...dados.current }); //atualizo o estado global
			setEntities(prevEntities => [...prevEntities, entityToAdd])

			// console.log("entidades atualizadas:", dados.current.info.entidades);

			//limpo o form da entidade
            setNewEntity({
                nomeEntidade: '',
                morada: '',
                codigoPostal: '',
                localidade: '',
                pais: '',
                dataPrimeiroRegisto: '',
                nif: '',
                telf: '',
                telm: '',
                nomeDominio: '',
                ssl: '',
                responsavelGestaoDominio: '',
                email: '',
                site: '',
                obs: ''
            });

            setIsAdding(false);
            console.log('entidade adicionada:', entityToAdd);
        } else {
            console.log('nome da entidade ou NIF não fornecido.');
        }
    };

	//veriica se newEntity tem um nomeEntidade antes de adicionar a nova entidade ao array de entidades dentro de dados.
	//Após adicionar, limpa o form e oculta a interface de adição (isAdding)
	const addDomain = (e) => {
		e.preventDefault();
		console.log("tentar adicionar um novo dominio:", newDomain);

		if (newDomain && newDomain.nomeEntidade && newDomain.nif) {
			const domainId = Date.now().toString();
			const domainToAdd = { ...newDomain, id: domainId };
			console.log("dominio a ser adicionado:", domainToAdd);
			dados.current.info.entidades.push(domainToAdd); 
			set_dados({ ...dados.current });
			setDominios(prevDominios => [...prevDominios, domainToAdd])

			console.log("dominios atualizados:", dados.current.info.entidades);

			setNewDomain({
				nomeEntidade: '',
				morada: '',
				codigoPostal: '',
				localidade: '',
				pais: '',
				dataPrimeiroRegisto: '',
				nif: '',
				telf: '',
				telm: '',
				nomeDominio: '',
				ssl: '',
				responsavelGestaoDominio: '',
				email: '',
				site: '',
				obs: ''
			});

			setIsAddingDomain(false);
			console.log('NOVO dominio adicionada:', domainToAdd);
		} else {
			console.log('nome do domain não fornecido.');
		}
	};

	const handleEditChange = (e) => {
		const { name, value } = e.target;
		console.log('campo editado:', name, 'novo valor:', value);
		setEditedEntity((prevState) => ({
			...prevState,
			[name]: value,
		}));
		// console.log('estado atualizado do editedEntity:', editedEntity);
		// console.log('ID da entidade em edição:', editingEntityId);

	};

	const saveEdit = () => {
		// console.log('entidade antes de clicar no btn salvar:', editedEntity);
		
		//crio um novo array que contem todas as entidades de dados.current.info.entidades
		//EXCETO a entidade que está a ser editada
		//faço a filtragem ao comparar os ID'S das entidades no array com o editingEntityId
		//SÓ as entidades cujo ID não coincide com o editingEntityId são mantidas no array_aux
		let array_aux = dados.current.info.entidades.filter(element =>
			parseInt(element.id) !== parseInt(editingEntityId) 
		)

		//adiciono a entidade editada (editedEntity) ao final do array array_aux
		//ou seja o array_aux tem todas as entidades anteriores exceto antiga versão da entidade que foi editada,substituída agora pela nova versão
		array_aux.push(editedEntity)
		// atualiza o estado 'dados' para refletir as mudanças. O array dados.current.info.entidades é substituído por array_aux, que contém a lista atualizada das entidades.
		set_dados(dados.current.info.entidades = array_aux); 
	
		// limpa o estado de editingEntityId e editedEntity, retornando-os ao valor inicial
		// isto encerra o modo de edição
		setEditingEntityId(null);
		setEditedEntity({});
	};

	
    const cancelEdit = () => {
        setEditingEntityId(null);
        setEditedEntity({});
    };

	//inicia a edição de uma entidade
	const handleEditClick = (entidade) => {
		// console.log("iniciando edição para a entidade:", entidade);
		setEditingEntityId(entidade.id);
		// console.log("ver editedEntity", editedEntity)
		setEditedEntity({ ...entidade }); // cópia da entidade para edição
	};


	//inicia a edição de um domínio
	const handleEditDomainClick = (dominio) => {
		console.log("iniciar edição para a dominio:", dominio);

		setEditingDomainId(dominio.id);

		console.log("ver editedDomain", editedDomain)
		setEditedDomain({ ...dominio }); // cópia da dominio para edição
	};

	//função para alternar a visibilidade das entidades
	const toggleEntityVisibility = (id) => {
		// console.log(`trocar a visibilidade para entidade com ID: ${id}`);
		setActiveEntityId(prevId => (prevId === id ? null : id));
	};

	//função para alternar a visibilidade daos dominios
	const toggleDomainVisibility = (id) => {
		console.log(`trocar a visibilidade para entidade com ID: ${id}`);
		setActiveDomainId(prevId => (prevId === id ? null : id));
	};

	// função para capturar as mudanças nos campos de domínio
	const handleEditTableHistoryChange = (e) => {
		const { name, value } = e.target;
	
    // atualizo o domínio editado com o novo valor
    setEditedDomain({
      ...editedDomain,
      [name]: value
    });
	console.log(`campo alteradooooo: ${name}, novo valor: ${value}`)
  }

  // função para salvar as alterações e atualizar o historico
	const handleSave = () => {
		// campos que quero monitorizar
		const fieldsToMonitor = ['nomeDominio', 'dataPrimeiroRegisto', 'validade', 'gestor', 'obs'];
	
		const newHistoryEntries = fieldsToMonitor
		.filter(field => previousDomain[field] !== editedDomain[field] && previousDomain[field] !== undefined)
		.map(field => ({
			field,
			oldValue: previousDomain[field],
			newValue: editedDomain[field],
			date: new Date().toLocaleString() // captura a data e hora
		}));
	
		// adiciona o novo histórico apenas se houver alterações
		if (newHistoryEntries.length > 0) {
		setHistory(prevHistory => [...prevHistory, ...newHistoryEntries]);
		setShowHistory(true); // Mostra a tabela do histórico quando houver alterações
		}
	
		// atualiza o estado com o domínio editado após salvar
		setPreviousDomain(editedDomain);
	};

	const handleCancel = () => {
		if (history.length > 0) {
		// obtenho a última alteração
		const lastChange = history[history.length - 1];
	
		// atualizo o estado editedDomain para o valor antigo do último campo modificado
		setEditedDomain((prevDomain) => ({
			...prevDomain,
			[lastChange.field]: lastChange.oldValue
		}));
	
		// removo a última alteração do historico
		setHistory((prevHistory) => prevHistory.slice(0, -1));
	
		console.log("Última alteração eliminada:", lastChange);
		}
	
		// Caso não exista mais historico, ocultar a tabela
		if (history.length === 1) {
		setShowHistory(false);
		}
	};

	const openModelResponsavel = (id, nome) => {
		// console.log('abril modal para o departamento:', nome)
		// console.log('abril modal para ver id do depart:', id)
		setDepartamentoSelecionado(nome)
		setDepartamentoId(id)
		setModalResponsavel(true)
		setResponsavelAdicionado(null)
	}

	const AddResponsavel = () => {
		// console.log('AddResponsavel chamado');
	
		// verifico se todos os inputs necessários estão preenchidos
		if (responsavelInputNome && responsavelInputTel && departamentoid) {
			// console.log('todos os inputs estão preenchidos');
			
			// itero pelos contatos para encontrar o departamento correspondente
			let departamentoAtual;
			dados.current.contacts.forEach(contact => {
				const departamento = contact.departments.find(dep => dep.id === departamentoid);
				if (departamento) {
					departamentoAtual = departamento;
				}
			});
	
			//verifico se o departamento foi encontrado
			if (departamentoAtual) {
				// console.log('departamento atual encontrado:', departamentoAtual);
	
				// encontro a lista de responsáveis dentro do departamento ou inicializa um array vazio
				let aux = departamentoAtual.person_responsables || [];
				// console.log('responsáveis atuais:', aux);
	
				// obtenho o último responsável da lista de responsáveis
				let last = aux[aux.length - 1];
				// console.log('último responsável:', last);
	
				//guardo o responsável anterior
				const responsavelAnterior = last ? { ...last } : null;
	
				//crio um novo responsável com um ID incrementado e os dados do input
				const novoResponsavel = {
					id: last ? parseInt(last.id) + 1 : 1,
					departmentID: departamentoid,
					nome: responsavelInputNome,
					tel: responsavelInputTel
				};
	
				//mostro o novo responsável que será adicionado
				console.log('novo responsável:', novoResponsavel);
	
				// add o novo responsável à lista de responsáveis
				// aux.push(novoResponsavel);
				aux[0]=novoResponsavel;
				console.log('lista de responsáveis após add:', aux);
	
				// atualizo a lista de responsáveis no departamento
				departamentoAtual.person_responsables = aux;
	
				//atualizo os contatos com a nova lista de responsáveis no useRef
				dados.current.contacts = dados.current.contacts.map(contact =>
					contact.departments.some(dep => dep.id === departamentoid)
						? { ...contact, departments: contact.departments.map(dep =>
							dep.id === departamentoid ? { ...dep, person_responsables: aux } : dep
						  )}
						: contact
				);
				// console.log('lista atualizadas:', dados.current.contacts);

				// mostro todos os departamentos e seus responsáveis
				console.log('todos os departamentos e seus responsáveis:');
				dados.current.contacts.forEach(contact => {
					contact.departments.forEach(departamento => {
						console.log(`Departamento ID: ${departamento.id}, Nome: ${departamento.nome}`);
						console.log('Responsáveis:', departamento.person_responsables);
					});
				});

				//mostro a lista de responsáveis do departamento atualizado
				const contatoAtualizado = dados.current.contacts.find(contact =>
					contact.departments.some(dep => dep.id === departamentoid)
				);

				if (contatoAtualizado) {
					const departamentoAtualizado = contatoAtualizado.departments.find(dep => dep.id === departamentoid);
					console.log('lista de responsáveis atualizada:', departamentoAtualizado.person_responsables);
				} else {
					console.log('Erro ao encontrar o contato atualizado.');
				}
	
				//mostro o responsável anterior e responsável atual
				if (responsavelAnterior) {
					console.log('Responsável anterior:', responsavelAnterior);
				} else {
					console.log('Não havia responsável anterior');
				}
	
				//atualizo o estado com o responsável adicionado
				setResponsavelAdicionado(novoResponsavel);
				console.log('responsável adicionado:', novoResponsavel);
	
				// fecho o modal
				setModalResponsavel(false);
				console.log('modal fechado');
	
				//limpo os campos de entrada
				setresponsavelInputNome('');
				setresponsavelInputTel('');
				console.log('campos de entrada limpos');
			} else {
				//indico que o departamento não foi encontrado
				console.log('departamento não encontrado:', departamentoid);
			}
		} else {
			//mostro quais campos estão a faltar
			console.log('faltam campos:', { 
				responsavelInputNome, 
				responsavelInputTel, 
				departamentoid 
			});
		}

		console.log("ver estrutura", dados.current.contacts[0])
	};
	
	const handleAddDepartamento = () => {
		let aux = dados.current.contacts[0].departments
		let last = dados.current.contacts[0].departments[dados.current.contacts[0].departments.length - 1];
		if (departamentoInput) {
			aux.push({ id: last.id + 1, nome: departamentoInput })
			setDepartamentoInput('');
			setIsModalOpen(false);
		}
		set_dados(dados.current.contacts[0].departments = aux)

		console.log(departamentoInput);
	};

	const custom_select_styles = {
		container: base => ({
			...base,
			borderRadius: "0px",
			width: '100%',
		}),
		control: base => ({
			...base,
			borderRadius: "0px",
			padding: "2px 10px",
			fontSize: '14px'
		}),
		menu: base => ({
			...base,
			borderRadius: "0px",
		}),
	}

	const change_country = e => {

		set_cities([])
		set_villages([])

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = '');

		if (e.value === "Portugal") {

			set_show_district_city_village('')

			if (districts.length === 0) {
				//console.log('DISTRITOS VAZIOS')
				obter_distritos_pt(set_districts)
			}
		}
		else {
			set_show_district_city_village('d-none')
		}

		set_dados(dados.current.addresses[0].country = e.value);
	}

	const change_district = e => {

		set_cities([])
		set_villages([])

		obter_cidades_por_distrito(e.value, set_cities)

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = e.value);
	}

	const change_city = e => {

		set_villages([])

		obter_freguesias_por_cidade(e.value, set_villages)

		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].city = e.value);
	}

	const change_village = e => {
		set_dados(dados.current.addresses[0].village = e.value);
		set_dados(dados)
	}

	const change_entity_type = e => {
		set_dados(dados.current.info.entity_type = e.value);
	}

	const change_identification_type = e => {
		set_dados(dados.current.info.identification.tipo_identificacao = e.value);
	}

	/*const change_district_by_city = async e => {

		return await obter_distrito_por_cidade(e.value)
			.then(res =>
				change_district({ value: res })
			).catch(() => { return } 
				//alert('Distrito não encontrado!')
			)
	}*/

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {

				if(res.data[0].contacts[0].email === '') {
					res.data[0].contacts[0].email = res.data[0].info.email
				}

				set_dados(dados.current = res.data[0]);
				//console.log(res)

			})
			.catch(error => alert(error)/*TODO: GO TO FAIL FETCH*/)
	}
	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	// PARA INSTANCIAR O COMPONENTE COM O ID 
	//const props_tmp = props
	useEffect(() => {

		clean_data();
		obter_paises_em_pt(set_countries);

		if(getTokenInfo().profile === 'Cliente') {

			set_is_edit(true)

			set_show_delete_button('d-none')

			fetch_id_info(getTokenInfo().id).then(() => {

				//console.log(dados.current)
				if (dados.current.addresses[0].country === 'Portugal') {

					obter_distritos_pt(set_districts)

					obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

					obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
					setLoading(false);
				}
				else {
					set_show_district_city_village('d-none')
					setLoading(false);
				}
			})
			return

		}

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {

				// console.log('000')

				//console.log('NO EDIT')
				set_is_edit(true)

				set_show_delete_button('')

				fetch_id_info(props.location.state.item['id']).then(() => {

					//console.log(dados.current)
					if (dados.current.addresses[0].country === 'Portugal') {

						obter_distritos_pt(set_districts)

						obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

						obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
						setLoading(false);
					}
					else {
						set_show_district_city_village('d-none')
						setLoading(false);
					}
				})
				return
			}
		} 
		catch {

			clean_data()

			setLoading(false);

			setRedirect(false);
			return

		}
		// BACK
		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}

	}, [props])

	//função é chamada quando o formulário é submetido.
	//se estiver em modo de edição (is_edit), exibe um modal de confirmação antes de fazer uma requisição PUT para atualizar a entidade.
	//se não estiver em modo de edição, utiliza a função addEntity para adicionar a nova entidade e faz uma requisição POST para salvar a entidade.
	const handleSubmit = async e => {
		e.preventDefault();
		// console.log("verificar estado de newEntity", newEntity)
		console.log('formulário enviado!')
		// console.log("verificar estado de newDomain", newDomain)
	
		if (is_edit === true) {
			// console.log("editar domínio")
			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					// dados.current.info.name = newEntity.nomeEntidade





					if(is_password) {
						let password = new_password;
						dados.current.info.password = passwordHash(password);
					}
					// console.log("enviar requisição PUT com os dados:", dados.current);
					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							set_new_password('');
							set_confirm_password('');
							// console.log("Entidade editada com sucesso.");
							// props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			});
		} else {
			// console.log("Adição de uma nova entidade")
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
	
					if(is_password) {
						let password = new_password;
						dados.current.info.password = passwordHash(password);
					}
					addEntity(e) //chamo addEntity para lidar com a atual adição da entidade
					addDomain(e) //chamo addDomain para lidar com a atual adição do domínio 
					console.log("enviar requisição POST com os dados:", dados.current);
					reqPOST(api_crud_route, dados.current)
						.then(() => {
							console.log("Nova entidade/domínio salvada com sucesso")
							set_new_password('');
							set_confirm_password('');
							setIsAdding(false) // fecho o form 
							setIsAddingDomain(false)
							// props.history.push(endpoints.list);
						})
						.catch((error) => {
							console.error('Erro a salvar a nova entidade/domínio:', error);
							Swal.fire(language[lang].insert_error, '', 'info');
						});            }
			});
		}
	};

	/*const handleSubmitVat = async e => {
		e.preventDefault();

		setLoading(true);
		get_vat_info(dados.current.info.vat)
			.then(res => {
				//console.log('---------- VAT INFO --------------')
				//console.log(res)

				if ((res.data.name !== '---') && (res.data.name !== '')) {
					clean_data();
					set_dados(dados.current.info.vat = res.data.vatNumber);
					set_dados(dados.current.info.name = res.data.name);
					set_dados(dados.current.addresses[0].address_detail = res.data.address);

					let aMorada = res.data.address.split("\n");
					// Verificar se pais é PT
					if (res.data.countryCode === 'pt') {
						//console.log('----------------------> É PT')

						change_country({ value: 'Portugal' })


						set_dados(dados.current.addresses[0].street_name = aMorada[1]);

						let city = aMorada[1];
						if (city !== undefined) {
							city = city.toLowerCase();
							city = city.charAt(0).toUpperCase() + city.slice(1);
							change_district_by_city({ value: city }).then(() => change_city({ value: city }))


							// After District -> City
							change_district_by_city({ value: city }).then(() => change_city({ value: city }))

							let aMoradaCP = aMorada[2].split(" ");
							set_dados(dados.current.addresses[0].postal_code = aMoradaCP[0]);
						}
					} else {
						//console.log('---------------------->NÃO È PT')
						set_dados(dados.current.addresses[0].street_name = aMorada[1]);
					}
				}
				else {

					Swal.fire('VAT não encotrado na base VIES.', '', 'info')

				}
				setLoading(false)
			})

			.catch(error => { setLoading(false); alert(error) });
	}*/

	const handleSubmitPassword = async e => {
		e.preventDefault();

		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqPUT(api_crud_route, dados.current)
					.then(() => { props.history.push(endpoints.list) })
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
			}
		})
	}

	function apagar() {
		
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(res => {
						/* alert(res.status === 200 ?
							'Registo Apagado com Sucesso' : 'Problema ao Apagar Registo'); */

						props.history.push(endpoints.list);
					})
					.catch(error => alert(error))

			}
		})
	};

	const load_entity = async (vat, entity) => {
		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`)
			.then(res => {
				//console.log(res.data)
				// res.data.map((k) => {
				// 	if(k['vat'] === vat) {
				// 		set_dados(dados.current.info.Cliente.id = k['id']);
				// 		set_dados(dados.current.info.Cliente.name = k['name']);
				// 	}
				// });

				let ja_existe = false
				res.data.forEach((k) => {
					//console.log(res.data)
					if (k['vat'] === vat) {
						ja_existe = true
						//set_visible_client_name(true)
						//set_dados(dados.current.info.Cliente.name = k['vat']);
					}
				})

				if (ja_existe === false) {
					//<Link to={{ pathname: '/client_regist', state: { item: vat, operation: 'newFromCredit' } }} />

					//console.log('NãO EXISTE ________________>');
					return

				} else {

					Swal.fire('Já Existe um Registo com este VAT.', '', 'info')

				}
			}
			)
	}

	const handle_change_addresses = (e, addresses_index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/
		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.addresses[addresses_index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_info = (e) => {
		const { name, value } = e.target;



		/* DEBUG*/
		// console.log('=== HANDLE CHANGE INFO ===');
		// console.log('NAME:' + name)
		// console.log('Value:' + value)

		// esta linha já manipula qualquer campo cujo name corresponda a uma propriedade em dados.current.info, incluindo main_function
		set_dados(dados.current.info[name] = value)

		// console.log('Estado atualizado dos dados.current.info:', JSON.stringify(dados.current.info, null, 2));

		if ((is_edit === false) && (name === 'vat')) {
			if (dados.current.info['vat'].length === 9) {
				// console.log('VAT identificado, carregando entidade...');
				load_entity(dados.current.info['vat'], object_type)
			}
		}
	}

	const handle_change_login = (e) => {
		const { value } = e.target;

		load_entity('username', value, '')
	}

	const handle_change_info_new_password = (e) => {
		const { value } = e.target;

		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;

		if (new_password !== '' && value === new_password) {

			set_dados(dados.current.info.password = passwordHash(new_password))
			set_disabled(false)
		}
		else {

			Swal.fire('Password de confirmação diferente da password inserida.', '', 'info')
			set_disabled(true)
		}
	}

	const handle_change_contacts = (e, index = 0) => {
		const { name, value } = e.target;
		/* DEBUG*/
		// console.log('NAME:' + name)
		// console.log('Value:' + value)
		set_dados(dados.current.contacts[index][name] = value)
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_info_identification = (e) => {
		const { name, value } = e.target;
		/* DEBUG*/
		//console.log('NAME:' + name)
		//console.log('Value:' + value)
		set_dados(dados.current.info.identificacao[name] = value)
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	return isloading ?
	
		<Loader />
		
		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<h1 className="dash-title"> {language[lang].entity_new}: </h1>
					{/* <p> {language[lang].entity} </p> */}
				</div>

				<div className={`dash-cards body`}>
                	<div className="container">

						<div className="row">
							<div className="mb-5 mb-xl-10">
								
								<div className="card"> 
								{/* Início do CARD que mostra a 'Informação de caráter público'-personal_data */}
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].personal_data}</h3>
										</div>
									</div>
									<div  id="div-content">
										<form id="form" onSubmit={handleSubmit}>
										
											<div className="card-body border-top p-4">

												<div className="row mb-5">
													{/* INÍCIO CARD NOME EMPRESA */}
													<div className="col-md-4">
													
														<label className="fs-5 fw-bold mb-2">{language[lang].name}</label>
														<input type="text" name="name" value={dados.current.info.name} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].name_placeholder} onChange={handle_change_info} />

													</div>
													{/* novo campo = ÁREAS DE ATUAÇÃO DA EMPRESA*/}
													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].main_function}</label>
														<input type="text" name="main_function"  inputMode='text'  value={dados.current.info.main_function} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].main_function_placeholder} onChange={handle_change_info}  />
							
													</div>
													{/* final campo = ÁREAS DE ATUAÇÃO DA EMPRESA* */}

													<div className="col-md-4"> 
														<label className="fs-5 fw-bold mb-2">{language[lang].email}</label>
														{/* SE dados.current.info.email_company NÃO É undefined e NÃO ESTÁ VAZIO, USo ESSE VALOR. */}
														{/* CASO CONTRÁRIO, utilizo  dados.current.contacts[0].email, o que indica que estou a selecionar o correo electrónico de um  primeiro contacto duma lista. */}
														{/* <input type="email" pattern={pattern_email} name="email_company" value={dados.current.info.email_company != undefined && dados.current.info.email_company != '' ? dados.current.info.email_company : dados.current.contacts[0].email} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].email_placeholder} onChange={handle_change_info} /> */}
														<input type="email" pattern={pattern_email} name="email" value={dados.current.info.email != undefined && dados.current.info.email != '' ? dados.current.info.email : dados.current.contacts[0].email} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].email_placeholder} onChange={handle_change_contacts} />

													</div>
														{/* TIPO DE CLIENTE */}
													{/* <div className="col-md-3 d-none">
														<label className="fs-5 fw-bold mb-2">{language[lang].type}</label>
														
														<Select
															className="div-select"
															options={entity_types}
															name="client_type"
															value={dados.current.info.entity_type === '' ? null : { label: dados.current.info.entity_type, value: dados.current.info.entity_type }}
															placeholder={language[lang].type_placeholder}
															onChange={change_entity_type}
															styles={custom_select_styles}
														/>
													</div> */}
														{/* fINAL CARD NOME EMPRESA */}
												</div>

												{/*
												<div className="row mb-5 d-none">
													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].type_identification}</label>
														
														<Select
															className="div-select"
															options={identification_types}
															name="identification_type"
															value={dados.current.info.identification.tipo_identificacao === '' ? null : { label: dados.current.info.identification.tipo_identificacao, value: dados.current.info.identification.tipo_identificacao }}
															placeholder={language[lang].type_identification_placeholder}
															onChange={change_identification_type}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].identification_number}</label>
														<input type="text" pattern="\d*" inputMode='numeric' maxLength="11" name="numero_identificacao" value={dados.current.info.identification.numero_identificacao} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].identification_number_placeholder} onChange={handle_change_info_identification} />
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].identification_validation}</label>
														<input type="date" name="validade_identificacao" value={dados.current.info.identification.validade_identificacao !== '' ? dados.current.info.identification.validade_identificacao : ''} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" onChange={handle_change_info_identification} /> 
													</div>
												</div>
												*/}
													{/* inicio do CARD CONTACTOS */}
												<div className="row">
													<div className="col-md-4 mb-5">
														<label className="fs-5 fw-bold mb-2">{language[lang].tlf}</label>

														<PhoneInput
															defaultCountry="PT"
															className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
															placeholder={language[lang].tlf_placeholder}
															value={dados.current.contacts[0].phone !== '' ? dados.current.contacts[0].phone : null}
															onChange={e => set_dados(dados.current.contacts[0].phone = e)} 
														/>
														
													</div>

													<div className="col-md-4"> 
														<label className="fs-5 fw-bold mb-2">{language[lang].tlm}</label>
														<PhoneInput
															defaultCountry="PT"
															className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
															placeholder={language[lang].tlm_placeholder}
															value={dados.current.contacts[0].mobile_phone !== '' ? dados.current.contacts[0].mobile_phone : null}
															onChange={e => set_dados(dados.current.contacts[0].mobile_phone = e)} 
														/>
														
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].website}</label>
														<input type="text"  minLength="9" inputMode='text' name="website" value={dados.current.info.website} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].website_placeholder} onChange={handle_change_info}  />
							
													</div>
												</div>
												<div className="row mb-5">
													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].country}</label>
														<Select
															className="div-select"
															options={countries}
															name="pais"
															value={dados.current.addresses[0].country === '' ? null : { label: dados.current.addresses[0].country, value: dados.current.addresses[0].country }}
															placeholder={language[lang].country_placeholder}
															onChange={change_country}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].district}</label>
														<Select
															className="div-select"
															options={districts}
															name="distrito"
															value={dados.current.addresses[0].region === '' ? null : { label: dados.current.addresses[0].region, value: dados.current.addresses[0].region }}
															placeholder={language[lang].district_placeholder}
															onChange={change_district}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].city}</label>
														<Select
															className="div-select"
															options={cities}
															name="concelho"
															value={dados.current.addresses[0].city === '' ? null : { label: dados.current.addresses[0].city, value: dados.current.addresses[0].city }}
															placeholder={language[lang].city_placeholder}
															onChange={change_city}
															styles={custom_select_styles}
														/>
													</div>
												</div>
												{/* final do CARD CONTACTOS */}

												<div className="row mb-3">
														<div >
															<label className="fs-5 fw-bold mb-2">{language[lang].morada} </label>
															<textarea name="address_detail" value={dados.current.addresses[0].address_detail} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" rows="4" onChange={handle_change_addresses} />
														</div>
															{/*CÓDIGO DEPARTAMENTOS */}
															<div className="col-md-3 mb-3 mx-3"></div>
																<label className="fs-5 fw-bold mt-2
																" >{language[lang].departments}</label>
																

																			<div>
													<div className="row mb-5">

														{/* departaments array */}
														<div className="col-md-8 fs-5 fw-bold ">
															<div >
																{dados.current.contacts[0].departments.map((department, index) => (
																	<li  key={index}>
																		{department.nome}
																		<button type="button" onClick={() => openModelResponsavel(department.id, department.nome)} className= "btn bg-dark my-2 rounded-pill-bord-5 text-light ms-4">Inserir responsável </button>
																	</li>
																))}
															</div>
														</div>

														<div className="col-md-8 mb-3">
														
														<div className="d-flex justify-content-center align-items-center">
														<button
															type="button"
															onClick={() => setIsModalOpen(true)}
															className="btn bg-dark my-2 fw-bolder rounded-pill-bord-5 text-light"
														>
															{language[lang].add_entity}
														</button>
													</div>
														</div>
													</div>
													{/* add responsables and show inside modal*/}
													{modalResponsavel && (

														<div
															className="modal show"
															style={{
																display: 'flex',
																justifyContent: 'center',
																alignItems: 'center',
																position: 'fixed',
																top: 0,
																left: 0,
																width: '100%',
																height: '100%',
																backgroundColor: 'rgba(0, 0, 0, 0.5)',
																zIndex: 1050,
																// pointerEvents: 'none',
															}}
														>
															<div
																className="modal-dialog"
																style={{
																	backgroundColor: 'white',
																	padding: '20px',
																	borderRadius: '5px',
																	width: '300px',
																	pointerEvents: 'auto',
																}}
															>


																<div className="modal-header">
																	<h1>  Departamento: {departamentoSelecionado} </h1>

																</div>
																<div className="modal-body">
																	<label>

																		<input
																			type="text"
																			className="form-control"
																			value={responsavelInputNome}
																			placeholder={language[lang].add_resp_name} 
																			onChange={(e) => setresponsavelInputNome(e.target.value)}
																			style={{ width: '100%', marginBottom: '10px' }}

																		/>
																		{console.log(responsavelInputNome)}
																	</label>
																	<label>
																		<input
																			type="number"
																			className="form-control"
																			value={responsavelInputTel}
																			placeholder= {language[lang].add_contact} 
																			onChange={(e) => setresponsavelInputTel(e.target.value)}
																			style={{ width: '100%', marginBottom: '10px' }}

																		/>
																	</label>
																	{/* DIV para visualizar o responsável acabdo de adicionar */}
																		{dados.current.contacts[0].departments.map((element, key) => {
																		console.log("elementtttttttttttttt", element)
																		if(element.id == departamentoid ) {

																		if(element.person_responsables !== undefined && element.person_responsables !== null && element.person_responsables.length > 0) {
																			return(
																				<div key={key} className="bg-primary">
																					<p><strong>Nome:</strong> {element.person_responsables[0].nome}</p>
																					<p><strong>Tel:</strong> {element.person_responsables[0].tel}</p>
																				</div> )
																		} else {
																			return(
																				<p key={key}>Nenhum responsávelllll adicionado ainda</p>)
																		}
																		} else {
																			return null
																		
																		}
																		})}
																</div>

																<div className="modal-footer">
																		<button type="button" className="btn bg-dark my-2 fw-bolder rounded-pill-bord-5 text-light" onClick={AddResponsavel}>Adicionar</button>
																		<button onClick={() => setModalResponsavel(false)} className="btn bg-dark my-2 rounded-pill-bord-5 text-light">Sair</button>
																</div>
															</div>
														</div>
													)}

																{/* add departaments */}
																			{isModalOpen && (
																				<div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.7)' }}>
																					<div className="modal-dialog modal-dialog-centered">
																						<div className="modal-content">
																							<div className="modal-header">
																								<h5 className="modal-title">Adicionar departamento</h5>
																								<button type="button" className="btn-close" onClick={() => setIsModalOpen(false)}></button>
																							</div>
																							<div className="modal-body">
																								<input
																									type="text"
																									value={departamentoInput}
																									className="form-control"
																									placeholder={language[lang].add_depart_name}  
																									onChange={(e) => setDepartamentoInput(e.target.value)}
																								/>
																							</div>
																							<div className="modal-footer">
																							<button type="button" className="btn bg-dark my-2 fw-bolder rounded-pill-bord-5 text-light" onClick={handleAddDepartamento}>Adicionar</button>

																								<button type="button" className="btn bg-dark my-2 rounded-pill-bord-5 text-light" onClick={() => setIsModalOpen(false)}>Sair</button>
																							</div>
																						</div>
																					</div>
																				</div>
																			)}
												</div>
																			{/* FINAL CODIGO DEPARTAMENTOS */}
												</div>
											</div>
											{/* INÍCIO DA SEGUNDA ATIVIDADE DADA PELO DOMINGOS */}

											{/* AQUI ENTIDADES */}
											<div className="card mb-5 px-5 mb-5">
    <div className="card-header border-0 px-4">
        <div className="card-title m-0">
            <h3 className="fw-bolder m-0">{language[lang].entidades}</h3>
        </div>
    </div>
    <div className="collapse show">
        <div className="card-body border-top p-4">
            <button
                type="button"
                className="btn btn-primary mb-3"
                onClick={() => {
                    setNewEntity({
                        nomeEntidade: '',
                        morada: '',
                        codigoPostal: '',
                        localidade: '',
                        pais: '',
                        dataPrimeiroRegisto: '',
                        nif: '',
                        telf: '',
                        telm: '',
                        nomeDominio: '',
                        ssl: '',
                        responsavelGestaoDominio: '',
                        email: '',
                        site: '',
                        obs: ''
                    });
                    setIsAdding(true)
					;
                }}
            >
                Adicionar Nova Entidade
            </button>

			{isAdding && (
    <div>
        {/* campos para adicionar nova entidade */}
        <div className="mb-3">
            <label className="form-label">Nome</label>
            <input
                type="text"
                className="form-control"
                name="nomeEntidade"
                value={newEntity.nomeEntidade || ''}
                onChange={handleChange}
            />
        </div>
		<div className="mb-5" >
				<CountrySelector setNewEntity={setNewEntity}/>
		</div>
        <div className="mb-3">
            <label className="form-label">Morada</label>
            <input
                type="text"
                className="form-control"
                name="morada"
                value={newEntity.morada || ''}
                onChange={handleChange}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Código-Postal</label>
            <input
                type="text"
                className="form-control"
                name="codigoPostal"
                value={newEntity.codigoPostal || ''}
                onChange={handleChange}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Localidade</label>
            <input
                type="text"
                className="form-control"
                name="localidade"
                value={newEntity.localidade || ''}
                onChange={handleChange}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Data de abertura ficha</label>
            <input
                type="text"
                className="form-control"
                name="dataPrimeiroRegisto"
                value={newEntity.dataPrimeiroRegisto || ''}
                onChange={handleChange}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Telf</label>
            <input
                type="text"
                className="form-control"
                name="telf"
                value={newEntity.telf || ''}
                onChange={handleChange}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Tlm</label>
            <input
                type="text"
                className="form-control"
                name="telm"
                value={newEntity.telm || ''}
                onChange={handleChange}
            />
        </div>
        {/* tabela para editar os campos  */}
        <table className="table table-bordered text-center my-5">
            <thead>
                <tr className="table-success">
                    <th scope="col"><strong>SSL</strong></th>
                    <th scope="col"><strong>Email</strong></th>
                    <th scope="col"><strong>Site</strong></th>
                    <th scope="col"><strong>Obs</strong></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <input
                            type="text"
                            className="form-control"
                            name="ssl"
                            value={newEntity.ssl || ''}
                            onChange={handleChange}
                        />
                    </td>
                    <td>
                        <input
                            type="text"
                            className="form-control"
                            name="email"
                            value={newEntity.email || ''}
                            onChange={handleChange}
                        />
                    </td>
                    <td>
                        <input
                            type="text"
                            className="form-control"
                            name="site"
                            value={newEntity.site || ''}
                            onChange={handleChange}
                        />
                    </td>
                    <td>
                        <input
                            type="text"
                            className="form-control"
                            name="obs"
                            value={newEntity.obs || ''}
                            onChange={handleChange}
                        />
                    </td>
                </tr>
            </tbody>
        </table>

        <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit}
        >
            Guardar
        </button>
        <button
            type="button"
            className="btn btn-secondary ms-2"
            onClick={() => {
                setIsAdding(false);
                setNewEntity({
                    nomeEntidade: '',
                    morada: '',
                    codigoPostal: '',
                    localidade: '',
                    pais: '',
                    dataPrimeiroRegisto: '',
                    nif: '',
                    telf: '',
                    telm: '',
                    nomeDominio: '',
                    ssl: '',
                    responsavelGestaoDominio: '',
                    email: '',
                    site: '',
                    obs: ''
                });
            }}
        >
            Cancelar
        </button>
    </div>
)}

{dados.current.info.entidades && dados.current.info.entidades.map((entidade, key) => (
    <div key={key} className="text-dark bg-opacity-50 my-2">
        <button
            type="button"
            className="btn btn-secondary mb-1"
            onClick={() => toggleEntityVisibility(entidade.id)}
        >
            {entidade.nomeEntidade}
        </button>
    

    {activeEntityId === entidade.id ? (
    <div className="mt-4">
        {editingEntityId === entidade.id ? (
            <div>
				<h4>Editar Entidade</h4>
                <div className="mb-3">
                    <label className="form-label"><strong>Nome:</strong></label>
                    <input
                        type="text"
                        className="form-control"
                        name="nomeEntidade"
                        value={editedEntity.nomeEntidade || ''}
                        onChange={handleEditChange}
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label"><strong>Morada:</strong></label>
                    <input
                        type="text"
                        className="form-control"
                        name="morada"
                        value={editedEntity.morada || ''}
                        onChange={handleEditChange}
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label"><strong>Código-Postal:</strong></label>
                    <input
                        type="text"
                        className="form-control"
                        name="codigoPostal"
                        value={editedEntity.codigoPostal || ''}
                        onChange={handleEditChange}
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label"><strong>Localidade:</strong></label>
                    <input
                        type="text"
                        className="form-control"
                        name="localidade"
                        value={editedEntity.localidade || ''}
                        onChange={handleEditChange}
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label"><strong>Data de Primeiro Registo:</strong></label>
                    <input
                        type="text"
                        className="form-control"
                        name="dataPrimeiroRegisto"
                        value={editedEntity.dataPrimeiroRegisto || ''}
                        onChange={handleEditChange}
                    />
                </div>

                <table className="table table-bordered text-center my-5">
                    <thead>
                        <tr className="table-success">
                            <th scope="col"><strong>SSL</strong></th>
                            <th scope="col"><strong>Email</strong></th>
                            <th scope="col"><strong>Site</strong></th>
                            <th scope="col"><strong>Obs</strong></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="ssl"
                                    value={editedEntity?.ssl || ''}
                                    onChange={handleEditChange}
                                />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="email"
                                    value={editedEntity?.email || ''}
                                    onChange={handleEditChange}
                                />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="site"
                                    value={editedEntity?.site || ''}
                                    onChange={handleEditChange}
                                />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="obs"
                                    value={editedEntity?.obs || ''}
                                    onChange={handleEditChange}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>

                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={saveEdit}
                >
                    Salvar
                </button>

                <button
                    type="button"
                    className="btn btn-secondary ms-2"
                    onClick={cancelEdit}
                >
                    Cancelar
                </button>
            </div>
        ) : (
            <div>
				<h4>Detalhes da Entidade</h4>
                <div className="row border border-dark border-1 py-2 mb-2">
                    <div><strong>Nome:</strong> {entidade.nomeEntidade}</div>
            </div>
                <div className="row border border-dark border-1 py-2 mb-2">
                    <div><strong>Morada:</strong> {entidade.morada}</div>
                </div>
                <div className="row border border-dark border-1 py-2 mb-2">
                    <div className="col-md-6"><strong>Código-Postal:</strong> {entidade.codigoPostal}</div>
                    <div className="col-md-6"><strong>Localidade:</strong> {entidade.localidade}</div>
                </div>
                <div className="row border border-dark border-1 py-2 mb-2">
                    <div className="col-md-6"><strong>Data de Abertura Ficha:</strong> {entidade.dataPrimeiroRegisto}</div>
                </div>
                <div className="row border border-dark border-1 py-2 mb-2">
                    <div className="col-md-6"><strong>Telf:</strong> {entidade.telf}</div>
                    <div className="col-md-6"><strong>Telm:</strong> {entidade.telm}</div>
                </div>
                <table className="table table-bordered text-center my-5">
                    <thead>
                        <tr className="table-success">
                            <th scope="col"><strong>SSL</strong></th>
                            <th scope="col"><strong>Email</strong></th>
                            <th scope="col"><strong>Site</strong></th>
                            <th scope="col"><strong>Obs</strong></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{entidade.ssl}</td>
                            <td>{entidade.email}</td>
                            <td>{entidade.site}</td>
                            <td>{entidade.obs}</td>
                        </tr>
                    </tbody>
                </table>
                <button
                    type="button"
                    className="btn btn-warning"
					onClick={() => handleEditClick(entidade)}
                >
                    Editar
                </button>
            </div>
        )}
    </div>
) : null}
                </div>
            ))}
        </div>
    </div>
</div>
						
												
					{/*INICIO DOS Domínios */}
					<div className="card mb-5 px-5 mb-5">
    <div className="card-header border-0 px-4">
        <div className="card-title m-0">
            <h3 className="fw-bolder m-0">{language[lang].dominios}</h3>
        </div>
    </div>
    <div className="collapse show">
        <div className="card-body border-top p-4">
            <button
                type="button"
                className="btn btn-primary mb-3"
                onClick={() => {
                    setNewDomain({
                        nomeEntidade: '',
                        morada: '',
                        codigoPostal: '',
                        localidade: '',
                        pais: '',
                        dataPrimeiroRegisto: '',
                        nif: '',
                        telf: '',
                        telm: '',
                        nomeDominio: '',
                        ssl: '',
                        responsavelGestaoDominio: '',
                        email: '',
                        site: '',
                        obs: ''
                    });
                    setIsAddingDomain(true);
                }}
            >
                Adicionar Novo Domínio
            </button>

			{isAddingDomain && (
    <div>
        {/* campos para adicionar novo domínio */}
        <div className="mb-3">
            <label className="form-label">Domínio</label>
            <input
                type="text"
                className="form-control"
                name="nomeDominio"
                value={newDomain.nomeDominio || ''}
                onChange={handleChangeDomain}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Estado</label>
            <input
                type="text"
                className="form-control"
                name="estado"
                value={newDomain.estado || ''}
                onChange={handleChangeDomain}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Gestão domínio</label>
            <input
                type="text"
                className="form-control"
                name="responsavelGestaoDominio"
                value={newDomain.responsavelGestaoDominio || ''}
                onChange={handleChangeDomain}
            />
        </div>
        {/* <div className="mb-3">
            <label className="form-label">Entidade</label>
            <input
                type="text"
                className="form-control"
                name="nomeEntidade"
                value={newDomain.nomeEntidade || ''}
                onChange={handleChangeDomain}
            />
        </div> */}
        <div className="mb-3">
            <label className="form-label">Registar</label>
            <input
                type="text"
                className="form-control"
                name="registar"
                value={newDomain.registar || ''}
                onChange={handleChangeDomain}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Data registo</label>
            <input
                type="text"
                className="form-control"
                name="dataPrimeiroRegisto"
                value={newDomain.dataPrimeiroRegisto || ''}
                onChange={handleChangeDomain}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Validade</label>
            <input
                type="text"
                className="form-control"
                name="validade"
                value={newDomain.validade || ''}
                onChange={handleChangeDomain}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Entidade Titular</label>
            <input
                type="text"
                className="form-control"
                name="titular"
                value={newDomain.titular || ''}
                onChange={handleChangeDomain}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Entidade Gestora</label>
            <input
                type="text"
                className="form-control"
                name="gestor"
                value={newDomain.gestor || ''}
                onChange={handleChangeDomain}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Responsável Técnico</label>
            <input
                type="text"
                className="form-control"
                name="tecnico"
                value={newDomain.tecnico || ''}
                onChange={handleChangeDomain}
            />
        </div>
		<div className="mb-3">
            <label className="form-label">Observações</label>
            <input
                type="text"
                className="form-control"
                name="obs"
                value={newDomain.obs || ''}
                onChange={handleChangeDomain}
            />
        </div>
		{/* tabela para editar os novos campos de dominios  */}
        <table className="table table-bordered text-center my-5">
            <thead>
                <tr className="table-success">
                    <th scope="col"><strong>Nome do Domínio</strong></th>
                    <th scope="col"><strong>Data de Registo</strong></th>
                    <th scope="col"><strong>Data de Início</strong></th>
                    <th scope="col"><strong>Data Fim</strong></th>
                    <th scope="col"><strong>Entidade Gestora</strong></th>
                    <th scope="col"><strong>Observações</strong></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <input
                            type="text"
                            className="form-control"
                            name="nomeDominio"
                            value={newDomain.nomeDominio || ''}
                            onChange={handleChangeDomain}
                        />
                    </td>
                    <td>
                        <input
                            type="text"
                            className="form-control"
                            name="dataPrimeiroRegisto"
                            value={newDomain.dataPrimeiroRegisto || ''}
                            onChange={handleChangeDomain}
                        />
                    </td>
                    <td>
                        <input
                            type="text"
                            className="form-control"
                            name="dataPrimeiroRegisto"
                            value={newDomain.dataPrimeiroRegisto || ''}
                            onChange={handleChangeDomain}
                        />
                    </td>
                    <td>
                        <input
                            type="text"
                            className="form-control"
                            name="validade"
                            value={newDomain.validade || ''}
                            onChange={handleChangeDomain}
                        />
                    </td>
                    <td>
                        <input
                            type="text"
                            className="form-control"
                            name="gestor"
                            value={newDomain.gestor || ''}
                            onChange={handleChangeDomain}
                        />
                    </td>
                    <td>
                        <input
                            type="text"
                            className="form-control"
                            name="obs"
                            value={newDomain.obs || ''}
                            onChange={handleChangeDomain}
                        />
                    </td>
                </tr>
            </tbody>
        </table>
        <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit}
        >
            Guardar
        </button>
        <button
            type="button"
            className="btn btn-secondary ms-2"
            onClick={() => {
                setIsAddingDomain(false);
                setNewDomain({
                    nomeEntidade: '',
                    morada: '',
                    codigoPostal: '',
                    localidade: '',
                    pais: '',
                    dataPrimeiroRegisto: '',
                    nif: '',
                    telf: '',
                    telm: '',
                    nomeDominio: '',
                    ssl: '',
                    responsavelGestaoDominio: '',
                    email: '',
                    site: '',
                    obs: ''
                });
            }}
        >
            Cancelar
        </button>
    </div>
)}

{dados.current.info.entidades && dados.current.info.entidades.map((entidade, key) => (
    <div key={key} className="text-dark bg-opacity-50 my-2">
        <button
            type="button"
            className="btn btn-secondary mb-1"
            onClick={() => toggleDomainVisibility(entidade.id)}
        >
            {entidade.nomeEntidade}
        </button>
    

    {activeDomainId === entidade.id ? (
    <div className="mt-4">
        {editingDomainId === entidade.id ? (
            <div>
				<h4 className= " my-5 bg-warning">Editar Domínio</h4>
                {/* campos para adicionar novo domínio */}
        <div className="mb-3">
            <label className="form-label">Domínio</label>
            <input
                type="text"
                className="form-control"
                name="nomeDominio"
                value={editedDomain.nomeDominio }
                onChange={handleEditTableHistoryChange}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Estado</label>
            <input
                type="text"
                className="form-control"
                name="estado"
                value={editedDomain.estado }
                onChange={handleEditTableHistoryChange}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Gestão domínio</label>
            <input
                type="text"
                className="form-control"
                name="responsavelGestaoDominio"
                value={editedDomain.responsavelGestaoDominio }
                onChange={handleEditTableHistoryChange }
            />
        </div>
        {/* <div className="mb-3">
            <label className="form-label">Entidade</label>
            <input
                type="text"
                className="form-control"
                name="nomeEntidade"
                value={editedDomain.nomeEntidade }
                onChange={handleEditTableHistoryChange}
            />
        </div> */}
        <div className="mb-3">
            <label className="form-label">Registar</label>
            <input
                type="text"
                className="form-control"
                name="registar"
                value={editedDomain.registar }
                onChange={handleEditTableHistoryChange}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Data registo</label>
            <input
                type="text"
                className="form-control"
                name="dataPrimeiroRegisto"
                value={editedDomain.dataPrimeiroRegisto }
                onChange={handleEditTableHistoryChange}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Validade</label>
            <input
                type="text"
                className="form-control"
                name="validade"
                value={editedDomain.validade }
                onChange={handleEditTableHistoryChange}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Entidade Titular</label>
            <input
                type="text"
                className="form-control"
                name="titular"
                value={editedDomain.titular}
                onChange={handleEditTableHistoryChange}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Entidade Gestora</label>
            <input
                type="text"
                className="form-control"
                name="gestor"
                value={editedDomain.gestor}
                onChange={handleEditTableHistoryChange}
            />
        </div>
        <div className="mb-3">
            <label className="form-label">Responsável Técnico</label>
            <input
                type="text"
                className="form-control"
                name="tecnico"
                value={editedDomain.tecnico}
                onChange={handleEditTableHistoryChange}
            />
        </div>
{/* DADOS ORIGINAIS */}
<div className="mt-5 d-none">
		<h3 className="mt-5">Dados originais da entidade: {entidade.nomeEntidade}</h3>
          <table className="table table-bordered text-center my-5">
            <thead>
              <tr className="table-warning">
                <th scope="col"><strong>Nome do domínio</strong></th>
                <th scope="col"><strong>Data do Primeiro Registo</strong></th>
                <th scope="col"><strong> Validade do domínio</strong></th>
                <th scope="col"><strong> Entidade Gestora</strong></th>
              </tr>
            </thead>
            <tbody>
			
              {/* {dados.current.info.entidades && dados.current.info.entidades.map((entidade, index) => ( */}
                <tr key={key}>
                  <td>{entidade.nomeDominio}</td>
                  <td>{entidade.dataPrimeiroRegisto}</td>
				  <td >{entidade.validade} </td>
				  <td>{entidade.gestor}</td>
                </tr>
            {/* //   ))} */}
            </tbody>
          </table>
		  </div>
		  {/* FINAL DOS DADOS ORIGINAIS */}



		{/* mostrar a tabela de historico se houver alterações */}
      {showHistory && history.length > 0 && (
        <div className="mt-5">
          <h4>Histórico dos Registos</h4>
          <table className="table table-bordered text-center my-5">
            <thead>
              <tr className="table-success">
                <th scope="col"><strong>Campo Alterado</strong></th>
                <th scope="col"><strong>Valor Antigo</strong></th>
                <th scope="col"><strong>Valor Novo</strong></th>
                <th scope="col"><strong>Data da Alteração</strong></th>
              </tr>
            </thead>
            <tbody>


        {/* mostra as alterações */}

              {history.map((entry, index) => (
			  entry.oldValue !== entry.newValue ? (
                <tr key={index}>
                  <td >{entry.field}</td>
                  {/* <td>{entry.oldValue}</td> */}
				  <td>
                {/* se o valor antigo estiver vazio, mostro o valor original da entidade */}
                {entry.oldValue || (
                  entry.field === 'nomeDominio' ? entidade.nomeDominio :
                  entry.field === 'dataPrimeiroRegisto' ? entidade.dataPrimeiroRegisto :
                  entry.field === 'validade' ? entidade.validade :
                  entry.field === 'gestor' ? entidade.gestor :
                  ''
                )}
              </td>
			  {/* 2 parametros a vermelho e 2 parametros a azul */}
				  {/* <td className={(entry.field === 'nomeDominio' || entry.field === 'validade') && entry.oldValue !== entry.newValue? "text-danger": (entry.field === 'gestor' || entry.field === 'dataPrimeiroRegisto') && entry.oldValue !== entry.newValue? "text-info": "" }> {entry.newValue}</td> */}

				  {/* só o dominio a vermelho */}
				  {/* <td className={entry.field === 'nomeDominio' && entry.oldValue !== entry.newValue ? "text-danger" : ""}>{entry.newValue} </td> */}
				  
				  {/* todos a azul */}
				<td className={(['nomeDominio', 'dataPrimeiroRegisto', 'validade', 'gestor'].includes(entry.field) && entry.oldValue !== entry.newValue) ? "text-info" : ""}>{entry.newValue} </td>
				  <td>{entry.date}</td>
                </tr>
				) : null
              ))}
            </tbody>
          </table>
        </div>
      )}
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSave}
                >
                    Salvar
                </button>

                <button
                    type="button"
                    className="btn btn-secondary ms-2"
                    onClick={handleCancel}
                >
                    Eliminar
                </button>
            </div>
        ) : (
            <div>
				<h4>Detalhes dos Domínios</h4>
                <div className="row border border-dark border-1 py-2 mb-2">
                    <div className="col-md-3"><strong>Domínio:</strong> {entidade.nomeDominio}</div>
					<div className="col-md-3"><strong>Estado:</strong> {entidade.estado}</div>
					<div className="col-md-3"><strong>Gestão domínio:</strong> {entidade.responsavelGestaoDominio}</div>
                </div>
                {/* <div className="row border border-dark border-1 py-2 mb-2">
                    <div className="col-md-6"><strong>Entidade:</strong> {entidade.nomeEntidade}</div>
                </div> */}
                <div className="row border border-dark border-1 py-2 mb-2">
                    <div className="col-md-3"><strong>Registar:</strong> {entidade.registar}</div>
                    <div className="col-md-3"><strong>Data Registo:</strong> {entidade.dataPrimeiroRegisto}</div>
					<div className="col-md-3"><strong>Validade:</strong> {entidade.validade}</div>
                </div>
                <div className="row border border-dark border-1 py-2 mb-2">
                    <div ><strong>Entidade Titular:</strong> {entidade.titular}</div>

                </div>
                <div className="row border border-dark border-1 py-2 mb-2">
                    <div ><strong>Entidade Gestora:</strong> {entidade.gestor}</div>
                </div>
				<div className="row border border-dark border-1 py-2 mb-4">
                    <div ><strong>Responsável Técnico:</strong> {entidade.tecnico}</div>
                </div>
                <button
                    type="button"
                    className="btn btn-warning my-5"
					onClick={() => handleEditDomainClick(entidade)}
                >
                    Editar
                </button>
            </div>
        )}
    </div>
) : null}
                </div>
            ))} 
        </div>
    </div>
</div>										 				
									{/* FINAL DOS DOMINIOSSSSSSSSSS - FINAL DA SEGUNDA ATIVIDADE DADA PELO DOMINGOS */}
												
										</form>
									</div>
								</div>
											{/* START 'Informação de caráter privado' */}
								<div className="card mb-5">
									<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_password">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].login_data}</h3>

										</div>
									</div>
									<div id="div_entidade_password" className="collapse show">
										<form id="form_user" onSubmit={handleSubmitPassword}>
											<div className="card-body border-top p-4">

												<div className="row mb-6"> 
												<div className="fs-5 fw-bold mb-2">Adicionar Trabalhador</div>

													<div className="col-md-4 fv-row">
														<label className="fs-5 fw-bold mb-2">{language[lang].username}</label>
														<input type="text" name="username" value={dados.current.info.username} pattern="[a-zA-Z\u00C0-\u00FF.]+" className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].username_placeholder} onChange={handle_change_info} onBlur={handle_change_login} autoComplete="off" />
													</div>
													<div className="col-md-4 fv-row">
														<label className="fs-5 fw-bold mb-2">{language[lang].password}</label>
														<input type="password" name="password" value={new_password} min="9" title="A password deve conter pelo menos 9 digitos alfa-númericos" className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onChange={handle_change_info_new_password} autoComplete="off" />
													</div>
													<div className="col-md-4 fv-row">
														<label className="fs-5 fw-bold mb-2">{language[lang].password_confirmation}</label>
														<input type="password" name="password_conf" defaultValue={confirm_password} min="9" className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onBlur={handle_change_password} autoComplete="off" />
													</div>


													{/* NOVO = B */}

													<div className="col-md-4 fv-row mb-2 d-none">
														<label className="fs-5 fw-bold mb-2">{language[lang].employeer_name}</label>
														<input type="text" name="employeer_name" value={dados.current.info.employeer_name} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].employeer_name_placeholder} onChange={handle_change_info} autoComplete="off"  />

													</div>
													<div className="col-md-4 fv-row mb-2 d-none">
														<label className="fs-5 fw-bold mb-2">{language[lang].employeer_role}</label>
													<div>
															<input
																type="text"
																name="employeer_function"
																value={dados.current.info.employeer_function || inputValueEmployeerFunction}
																// pattern={pattern_email}
																className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
																placeholder={language[lang].employeer_role_placeholder}
																onChange={handleChangeEmployeerFunction}
																onKeyDown={handleKeyDownEmployeerFunction}
																autoComplete="off"
															/>
															{submittedValueEmployeerFunction && <p>{submittedValueEmployeerFunction}</p>}
															</div>

													</div>

													 {/* NOVO = C */}
													 <div className="col-md-4 fv-row d-none">
														<label className="fs-5 fw-bold mb-2">{language[lang].employeer_type}</label>
														<input
															type="text"
															name="employeer_type"
															value={inputValueEmployeerType}
															pattern="[a-zA-Z\u00C0-\u00FF.]+"
															className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
															placeholder={language[lang].employeer_type_placeholder}
															onChange={handleChangeEmployeerType}
															onKeyDown={handleKeyDownEmployeerType}
															autoComplete="off"
														/>
														{submittedValueEmployeerType && (
															<div>
															<p>{submittedValueEmployeerType}</p> 
															</div>
														)}




													</div>
													{/* DISPLAY NONE */}
													{/* <div className="col-md-4 fv-row d-none">
														<label className="fs-5 fw-bold mb-2">{language[lang].employeer_id}</label>
														<input type="password" name="password" value={new_password} min="9" title="A password deve de conter pelo menos 9 digitos alfa-númericos" className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].employeer_id_placeholder} onChange={handle_change_info_new_password} autoComplete="off" />
													</div> */}
													<div className="col-md-4 fv-row d-none"> 
														<label className="fs-5 fw-bold mb-2">{language[lang].employeer_email}</label>
														<input type="email" pattern={pattern_email} name="email_company" value={dados.current.info.email_company != undefined && dados.current.info.email_company != '' ? dados.current.info.email_company : dados.current.contacts[0].email} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].employeer_email_placeholder} onChange={handle_change_info} />
													</div>
													{/* DISPLAY NONE */}
													{/* <div className="col-md-4 fv-row d-none">
														<label className="fs-5 fw-bold mb-2">{language[lang].employeer_insurance}</label>
														<input type="password" name="password_conf" defaultValue={confirm_password} min="9" className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].employeer_insurance_placeholder} onBlur={handle_change_password} autoComplete="off" />
													</div> */}
													<div className="col-md-4 fv-row mb-2 d-none">
														<label className="fs-5 fw-bold mb-2">{language[lang].vat}</label>
														<input type="text" name="vat" inputMode='numeric' value={dados.current.info.vat} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].vat_placeholder} onChange={handle_change_info} autoComplete="off"  />

													</div>

													{/* DISPLAY NONE TELEMOVEL */}
													{/* <div className="col-md-4 d-none"> 
														<label className="fs-5 fw-bold mb-2">{language[lang].tlm}</label>
														<PhoneInput
															defaultCountry="PT"
															className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
															placeholder={language[lang].tlm_placeholder}
															value={dados.current.contacts[0].mobile_phone !== '' ? dados.current.contacts[0].mobile_phone : null}
															onChange={e => set_dados(dados.current.contacts[0].mobile_phone = e)} 
														/>
														
													</div> */}		
												</div>
													{/* BUTOES */}
												{/* <div className="card-footer d-flex justify-content-end py-6 px-9 mb-5">
													<Link className="btn btn-light btn-active-light-primary me-2" to={{ pathname: endpoints.list }}  >
														<span>{language[lang].cancel}</span>
													</Link>

													<button onClick={() => apagar(dados.current.id)} className={show_delete_button ? "btn btn-danger me-2" : "hello nesta linha estava d-none"}>
														<span>{language[lang].delete}</span>
													</button>

													<button type="submit" form="form_user" className="btn btn-primary">
														<span>{language[lang].save}</span>
													</button>
												</div> */}
												{/* END DISPLAY BUTOES */}
											</div>
										</form>
									</div>
									
								</div>
								{/* END CARATER PRIVADO */}
							</div>
						</div>
					</div>
				</div>
				
						{/* ÍNÍCIO DOS BÕTÕES QUE ESTOU A UTILIZAR */}
										<div className={'dash-cards footer'}>
											<nav className="navbar bottom-navbar navbar-light">
												<div className="navbar-footer">
													<ul className="navbar-nav float-left"></ul>
													<ul className="navbar-nav float-right">
														<li className={(getTokenInfo().profile === 'Cliente') ? 'd-none' : "nav-item" + ' ' + getTokenInfo().profile}>
															<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
																<i className="bi bi-chevron-left me-2"></i>
																<span>{language[lang].back}</span>
															</Link>
														</li>
														<li className={"nav-item " + show_delete_button}>
															<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
																<i className="bi bi-trash3 me-2"></i>
																<span>{language[lang].delete}</span>
															</button>
														</li>
														<li className="nav-item">
															<button type="submit" form="form" className="nav-link">
																<i className="bi bi-floppy me-2"></i>
																<span>{language[lang].save}</span>
															</button>
														</li>
													</ul>
												</div>
											</nav>
										</div>
										{/* FINAL DOS BÕTÕES */}
			</main >
}